import { Stack, Typography } from '@mui/material';
import { useAppTFunction } from '@retail/app/i18n';
import { ErrorFallback, PageLayout, SuspenseWithSentryErrorBoundary } from '@retail/components';
import { Paper, TagHeading } from '@shared/components';
import { PriceControlSuppliersView } from '@retail/price-control/containers';

export function PriceControlPage() {
  const t = useAppTFunction();

  return (
    <PageLayout maxWidth="full" fixedHeight>
      <Paper sx={{ height: '100%', display: 'flex', flexDirection: 'column', p: 0 }}>
        <TagHeading sx={{ p: 3 }}>
          <Typography variant="h4">{t('app.routes.priceControl')}</Typography>
        </TagHeading>
        <SuspenseWithSentryErrorBoundary
          errorFallback={
            <Stack flexGrow={1} justifyContent="center">
              <ErrorFallback />
            </Stack>
          }
        >
          <PriceControlSuppliersView />
        </SuspenseWithSentryErrorBoundary>
      </Paper>
    </PageLayout>
  );
}
